import { windowEnvVar } from "./envUtil";

export const getPollInterval = () => {
  return windowEnvVar("NOTIFICATION_POLL_INTERVAL") ?? (process.env.REACT_APP_NOTIFICATION_POLL_INTERVAL || -1);
};
